import React from 'react';

const Marquee = ({
  children,
  speed = 30,
  direction = 'left',
  pauseOnHover = true,
  className = '',
}) => {
  const isReverse = direction === 'right';

  return (
    <div
      className={`overflow-hidden mask-fade-edges ${pauseOnHover ? 'group' : ''} ${className}`}
    >
      <div
        className={`flex w-max ${isReverse ? 'animate-marquee-reverse' : 'animate-marquee'} ${
          pauseOnHover ? 'group-hover:[animation-play-state:paused]' : ''
        }`}
        style={{ '--marquee-duration': `${speed}s` }}
      >
        <div className="flex shrink-0 items-center gap-4">{children}</div>
        <div className="flex shrink-0 items-center gap-4" aria-hidden="true">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Marquee;
